export const surchargeTypes = [
    { name: 'vat', type: 1 },
    // {name:'stateTax', type:2},
    // {name:'federalTax', type:3},
    // {name:'cityTax', type:4},
    { name: 'deposit', type: 5 },
    // {name:'plasticTax', type:6},
    // {name:'depositTax', type:7},
    // {name:'unknownTax', type:99},
];

export const surgeValueType = [
    { name: 'percentage', type: 1 },
    { name: 'fixedAmount', type: 2 },
];

export const appliedOn = [
    { name: 'originalPrice', value: 'base' },
    { name: 'cumulativePrices', value: 'all' },
];
